import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María José', 'Claudia', 'Sebastián', 'Valeria', 'Diego', 'Romina', 'Fernanda', 'Lucas', 'Carolina', 'Martín', 'Gabriela', 'Pablo', 'Natalia', 'Andrés', 'Sofía'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Corrientes', 'Misiones'];
export function PopupNotification() {
  const [visible, setVisible] = useState(false);
  const [info, setInfo] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showRandomNotification();
    }, 3000);
    const interval = setInterval(() => {
      showRandomNotification();
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const showRandomNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setInfo({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    setTimeout(() => setVisible(false), 5000);
  };
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs transition-all duration-500" style={{
    transform: visible ? 'translateX(0)' : 'translateX(-120%)',
    opacity: visible ? 1 : 0
  }} data-id="element-3">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-green-500" data-id="element-4">
        <div className="relative" data-id="element-5">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-6">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-7" />
          </div>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-ping" data-id="element-8" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full" data-id="element-9" />
        </div>
        <div data-id="element-10">
          <p className="text-xs text-gray-500 mb-0.5" data-id="element-11">📚 Compra reciente</p>
          <p className="text-sm font-bold text-gray-800" data-id="element-12">
            {info.name} de {info.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-13">
            acaba de comprar este libro digital
          </p>
        </div>
        <button onClick={() => setVisible(false)} className="ml-auto text-gray-400 hover:text-gray-600 text-lg leading-none" data-id="element-14">
          ×
        </button>
      </div>
    </div>;
}